'use es6';

import { BASE_BACKGROUND_COLOR_MEDIUM } from 'HubStyleTokens/theme';
export var CARD_BACKGROUND = BASE_BACKGROUND_COLOR_MEDIUM;
export var DEVICE_CLASSES = {
  mobile: 'private-template--mobile',
  tablet: 'private-template--tablet',
  desktop: 'private-template--desktop'
};
export var LAYOUT_CLASSES = {
  'full-width': 'private-template--full-width',
  'max-width': 'private-template--centered'
};
export var LAYOUT_TYPES = ['flex', 'grid'];